import React from 'react'
import { Link } from 'react-router-dom'
import KrinoLogo from '../../assets/img/login/Krino_logo.png'


export const LoginHeader = () => {
  return (
    <header className="login__header">
      <Link to='/login'>
        <img src={KrinoLogo} alt="krino logo" />
      </Link>
      <div className="login__header__linksContainer">
        <a
          href='https://krino.ai/blog/'
          target='_blank'
          rel='noopener noreferrer'
        >
            Blog
        </a>
        <a 
          // href='https://krino.ai/blog/category/tutoriales/'
          href='https://krino.ai/blog/'
          target='_blank'
          rel='noopener noreferrer'
        >
            KrinoUniversity
        </a>
      </div>
    </header>
  )
}